import { render, staticRenderFns } from "./ImageProduct.vue?vue&type=template&id=9b2c99d0&"
import script from "./ImageProduct.vue?vue&type=script&lang=js&"
export * from "./ImageProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports